<section class="form-card">
  <header class="login-card-header">
    <img class="login-card-title" src="assets/img/login/login.svg">
    <h3 class="login-card-subtitle">Pour profiter de tous mes avantages …</h3>
  </header>

  <section class="login-card-body text-center">
    <p>La connexion à votre espace client est sécurisée par le service d’identité Castorama.</p>
    <a (click)="onSwitchContext(LoginContext.forgottenPassword)"
       class="casto-link forgotten-password-link">Mot de passe oublié</a>
  </section>

  <footer class="login-card-footer">
    <ng-casto-btn class="blue"
                  label="Je me connecte"
                  (click)="loginUser()"
                  [loading]="loading"></ng-casto-btn>

    <p class="mt-3" *ngIf="responsive.isMobile">
      <small>
        Je n’ai pas encore d’espace !
        <a (click)="createCard()"
           class="casto-link">Je crée ma carte de fidélité</a>
      </small>
    </p>
  </footer>
</section>
